import { IFormattedApiError } from '../api/core/types';
import { createAction } from '../helpers';
import {
  EAsyncActionTypes,
  EAsyncEventTypes,
  TAddErrorAction,
  THideLoaderAction,
  THideToasterAction,
  TRemoveErrorAction,
  TShowLoaderAction,
  TShowToasterAction,
} from './types';

const addError = (
  asyncEventName: EAsyncEventTypes,
  error: IFormattedApiError
): TAddErrorAction =>
  createAction(EAsyncActionTypes.ADD_ERROR, { asyncEventName, error });

const removeError = (asyncEventName: EAsyncEventTypes): TRemoveErrorAction =>
  createAction(EAsyncActionTypes.REMOVE_ERROR, { asyncEventName });

const showLoader = (asyncEventName: EAsyncEventTypes): TShowLoaderAction =>
  createAction(EAsyncActionTypes.SHOW_LOADER, { asyncEventName });

const hideLoader = (asyncEventName: EAsyncEventTypes): THideLoaderAction =>
  createAction(EAsyncActionTypes.HIDE_LOADER, { asyncEventName });

const showToaster = (asyncEventName: EAsyncEventTypes): TShowToasterAction =>
  createAction(EAsyncActionTypes.SHOW_TOASTER, { asyncEventName });

const hideToaster = (asyncEventName: EAsyncEventTypes): THideToasterAction =>
  createAction(EAsyncActionTypes.HIDE_TOASTER, { asyncEventName });

export const asyncStateActions = {
  addError,
  removeError,
  showLoader,
  hideLoader,
  showToaster,
  hideToaster,
};
